import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import ReactDOM from "react-dom";
import close from "../assets/icons/close.svg";
import '../assets/css/Attendance.css'
const drawerVariants = {
  hidden: { x: "100%" },  // slide out
  visible: { x: "0" },   // slide in
  exit: { x: "100%" },    // slide out again
};

const backdropVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 0.5 },
  exit: { opacity: 0 },
};
const SideDrawer = ({ isOpen, onClose, children, zoomedOut }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <AnimatePresence>
      {/* Backdrop */}
      <motion.div
        key="backdrop"
        initial="hidden"
        animate="visible"
        exit="exit"
        
        variants={backdropVariants}
        onClick={onClose}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
         width: "100%",

          zIndex: 1999,
        }}
      />

      {/* Drawer */}
      <motion.div
        key="drawer"
        initial="hidden"
        animate="visible"
        exit="exit"
        className="side-drawer"
        variants={drawerVariants}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        style={{
          position: "fixed",
          top: 0,
          right: 0,
           bottom: 0,
          width: zoomedOut ? "70%" : "80%",
          background: "#fff",
          boxShadow: "-4px 0 15px rgba(0,0,0,0.2)",
          zIndex: 2000,
          display: "flex",
          flexDirection: "column",
          // overflowY: "auto",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "30px 20px",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <h2 style={{ margin: 0, fontSize: "21px", color: "#7F56DA" }}>
            Attendance Summary
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: 0,
            }}
          >
            <img src={close} alt="close" />
          </button>
        </div>

        {/* Content */}
     <div style={{ flex: 1, padding: "20px",  overflowX: "auto", overflowY: "auto", display: "flex", flexDirection: "column"  }} className="drawerContainer">
    {children} {/* AttendanceReport table should fill this */}
  </div>
      </motion.div>
    </AnimatePresence>,
    document.body
  );
};

export default SideDrawer;
